<template>
  <v-card>
    <v-dialog
      v-model="dialogUpload"
      width="500"
    >

      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
          Upload a file
        </v-card-title>

        <v-card-text>
          <Upload :folder="currentFolder"></Upload>
        </v-card-text>

        <v-divider></v-divider>

      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogFolder"
      width="500"
    >

      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
          Create a new folder
        </v-card-title>

        <v-card-text>
          <v-text-field
           v-model="newFolderName"
           :counter="10"
           label="Folder name"
           required
         ></v-text-field>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            flat
            @click="createFolder()"
          >
            Create folder
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

   <v-toolbar color="blue-grey darken-2" dark>
     <v-toolbar-side-icon @click="backBtn()">
       <v-icon>arrow_back</v-icon>
     </v-toolbar-side-icon>
     <v-toolbar-title v-if="!client.name">File manager</v-toolbar-title>
     <v-toolbar-title>{{client.name}}<span v-if="folder">/{{folder}}</span></v-toolbar-title>

     <v-spacer></v-spacer>

     <v-btn icon @click="dialogUpload = true">
       <v-tooltip bottom>
         <template v-slot:activator="{ on }">
           <v-icon v-on="on">cloud_upload</v-icon>
         </template>
         <span>Upload a file</span>
      </v-tooltip>
     </v-btn>

     <v-btn icon @click="dialogFolder = true">
       <v-tooltip bottom>
         <template v-slot:activator="{ on }">
           <v-icon v-on="on">create_new_folder</v-icon>
         </template>
         <span>Create directory</span>
      </v-tooltip>
     </v-btn>

     <v-btn v-if="this.isAdmin" icon @click="deleteClient()">
       <v-tooltip bottom>
         <template v-slot:activator="{ on }">
           <v-icon v-on="on">delete_forever</v-icon>
         </template>
         <span>Delete client</span>
      </v-tooltip>
     </v-btn>
   </v-toolbar>

   <v-list two-line subheader id="files-list">
     <v-subheader v-if="folders.length > 0" inset>Folders</v-subheader>

     <v-list-tile
       v-for="folder in folders"
       :key="folder.name"
       avatar
       @click="openFolder(folder)"
     >
       <v-list-tile-avatar>
         <v-icon class="grey lighten-1 white--text">folder</v-icon>
       </v-list-tile-avatar>

       <v-list-tile-content>
         <v-list-tile-title>{{ folder.name }}</v-list-tile-title>
       </v-list-tile-content>

       <v-list-tile-action>
         <v-btn icon ripple @click="deleteFolder(folder)">
           <v-tooltip bottom>
             <template v-slot:activator="{ on }">
               <v-icon color="grey lighten-1" v-on="on">delete_forever</v-icon>
             </template>
             <span>Delete</span>
          </v-tooltip>
         </v-btn>
       </v-list-tile-action>
     </v-list-tile>

     <v-divider inset></v-divider>

     <v-subheader v-if="files.length > 0" inset>Files</v-subheader>

     <v-list-tile
       v-for="file in files"
       :key="file.name"
       avatar
     >
       <v-list-tile-avatar>
         <v-icon class="blue white--text">assignment</v-icon>
       </v-list-tile-avatar>

       <v-list-tile-content>
         <v-list-tile-title>{{ file.name }}</v-list-tile-title>
         <v-list-tile-sub-title>{{ file.created }}</v-list-tile-sub-title>
       </v-list-tile-content>

       <v-list-tile-action>
         <v-btn icon ripple @click="copyLink(file)">
           <v-tooltip bottom>
             <template v-slot:activator="{ on }">
               <v-icon v-on="on" color="grey lighten-1">link</v-icon>
             </template>
             <span>Copy link</span>
          </v-tooltip>
         </v-btn>
       </v-list-tile-action>
       <v-list-tile-action>
         <a @click="download(file)" target="_blank">
           <v-btn icon ripple>
             <v-tooltip bottom>
               <template v-slot:activator="{ on }">
                 <v-icon color="grey lighten-1" v-on="on">cloud_download</v-icon>
               </template>
               <span>Download</span>
            </v-tooltip>
           </v-btn>
        </a>
       </v-list-tile-action>
       <v-list-tile-action>
         <v-btn icon ripple @click="deleteFile(file)">
           <v-tooltip bottom>
             <template v-slot:activator="{ on }">
               <v-icon color="grey lighten-1" v-on="on">delete_forever</v-icon>
             </template>
             <span>Delete</span>
          </v-tooltip>
         </v-btn>
      </v-list-tile-action>
     </v-list-tile>
   </v-list>
 </v-card>

</template>


<script>
  import firebase from 'firebase'
  import db from '../../main.js'
  import {store} from '../../store/store.js'
  import Vuex from 'vuex'
  import Upload from '../Upload.vue'
  import router from '../../router/index.js'

  export default {
    name: 'FileManager',
    props: ['client', 'folder', 'file'],
    components: {Upload},
    store: store,
    data: function() {
      return {
        folders: [],
        files: [],
        company: null,
        clients: [],
        dialogUpload: false,
        dialogFolder: false,
        currentFolder: null,
        newFolderName: null
      }
    },
    computed: {
      user() {
        return this.$store.getters.getUser;
      },
      isAdmin() {
        return this.$store.getters.getAdmin;
      }
    },
    methods: {
      updateData() {
        this.folders = [];
        this.files = [];
        this.currentFolder = {name:"root", company:this.client.uid};
        if (!this.client) {
          var self=this;
          db.collection('users').where('id', '==', firebase.auth().currentUser.uid).get().then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
              console.log(doc.id, ' => ', doc.data())
              self.company = doc.data().company
            })
          })
          db.collection('companies').get().then((querySnapshot) => {
            this.loading = false
            querySnapshot.forEach((doc) => {
              let data = {
                'uid': doc.id,
                'name': doc.data().name
              }
              self.clients.push(data)
            })
          })
          setTimeout(function () {
            self.client = self.clients.find(client => client.name === self.company);
          }, 1000);
        }
        if (this.client && this.file) {
          if (this.folder) {
            db.collection('files').where('name', '==', this.file).where('folder', '==', this.folder).where('company', '==', this.client.uid).get().then((querySnapshot) => {
              this.loading = false
              querySnapshot.forEach((doc) => {
                let data = {
                  'uid': doc.id,
                  'name': doc.data().name,
                  'folder': doc.data().folder,
                  'created': doc.data().created,
                  'company': doc.data().company,
                  'user': doc.data().user,
                  'bucketRef': doc.data().bucketRef
                }
                this.files.push(data)
                this.download(this.files[0])
                // window.open(this.files[0].bucketRef, '_blank');
              })
            })
          } else {
            db.collection('files').where('name', '==', this.file).where('company', '==', this.client.uid).get().then((querySnapshot) => {
              this.loading = false
              querySnapshot.forEach((doc) => {
                let data = {
                  'uid': doc.id,
                  'name': doc.data().name,
                  'folder': doc.data().folder,
                  'created': doc.data().created,
                  'company': doc.data().company,
                  'user': doc.data().user,
                  'bucketRef': doc.data().bucketRef
                }
                this.files.push(data)
                window.open(this.files[0].bucketRef, '_blank');
              })
            })
          }
        }
        else if (this.client && this.folder) {
          this.currentFolder = {name:this.folder, company:this.client.uid};
          console.log("CONDITION MET " + this.client + " " + this.folder);
          db.collection('folders').where('folder', '==', this.folder).where('company', '==', this.client.uid).get().then((querySnapshot) => {
            this.loading = false
            querySnapshot.forEach((doc) => {
              let data = {
                'uid': doc.id,
                'name': doc.data().name,
                'folder': doc.data().folder,
                'created': doc.data().created,
                'company': doc.data().company
              }
              this.folders.push(data)
              console.log(data);
            })
          })
          db.collection('files').where('folder', '==', this.folder).where('company', '==', this.client.uid).get().then((querySnapshot) => {
            this.loading = false
            querySnapshot.forEach((doc) => {
              let data = {
                'uid': doc.id,
                'name': doc.data().name,
                'folder': doc.data().folder,
                'created': doc.data().created,
                'company': doc.data().company,
                'user': doc.data().user,
                'bucketRef': doc.data().bucketRef
              }
              this.files.push(data)
              console.log(data);
            })
          })
        } else {
          db.collection('folders').where('company', '==', this.client.uid).where('folder', '==', 'root').get().then((querySnapshot) => {
            this.loading = false
            querySnapshot.forEach((doc) => {
              let data = {
                'uid': doc.id,
                'name': doc.data().name,
                'folder': doc.data().folder,
                'created': doc.data().created,
                'company': doc.data().company
              }
              this.folders.push(data)
            })
          })
          db.collection('files').where('company', '==', this.client.uid).where('folder', '==', 'root').get().then((querySnapshot) => {
            this.loading = false
            querySnapshot.forEach((doc) => {
              let data = {
                'uid': doc.id,
                'name': doc.data().name,
                'folder': doc.data().folder,
                'created': doc.data().created,
                'company': doc.data().company,
                'user': doc.data().user,
                'bucketRef': doc.data().bucketRef
              }
              this.files.push(data)
            })
          })
        }
      },
      copyLink(file) {
          let link = '';
          if (window.location.port) {
            link = window.location.protocol + "//" + window.location.hostname + ':' + window.location.port + '/#/files/' + this.client.name + '/' + file.folder + '/' + file.name;
          } else {
            link = window.location.protocol + "//" + window.location.hostname + '/#/files/' + this.client.name + '/' + file.folder + '/' + file.name;
          }
          this.copyToClipboard(link);
      },
      copyToClipboard(text){
          var dummy = document.createElement("input");
          document.body.appendChild(dummy);
          dummy.setAttribute('value', text);
          dummy.select();
          document.execCommand("copy");
          document.body.removeChild(dummy);
      },
      openFolder(folder) {
        this.folders = [];
        this.files=[];
        this.currentFolder = folder;
        console.log(folder.uid);
        router.push({ name: 'Folder', params: { client: this.client.name, folder: folder.name } });
        var self= this;
      },
      createFolder() {
        var self = this;
        db.collection('folders').add({
          name: this.newFolderName,
          folder: this.currentFolder.name,
          company: this.currentFolder.company,
          created: new Date()
        })
          .then(function (docRef) {
            console.log('Document written with ID: ', docRef.id)
            self.updateData();
            self.dialogFolder = false;
          })
          .catch(function (error) {
            console.error('Error adding document: ', error)
          })
      },
      backBtn() {
        router.go(-1);
        this.updateData();
      },
      // downloadFile(file) {
      //   function onStartedDownload(id) {
      //     console.log(`Started downloading: ${id}`);
      //   }
      //
      //   function onFailed(error) {
      //     console.log(`Download failed: ${error}`);
      //   }
      //
      //   var downloading = browser.downloads.download({
      //     url : file.bucketRef,
      //     filename : file.name,
      //     conflictAction : 'uniquify'
      //   });
      //
      //   downloading.then(onStartedDownload, onFailed);
      //
      // },
      download(file) {

        var storageRef = firebase.storage().ref('files/');
        var fileRef = storageRef.child(file.company + '/' + file.name);
        fileRef.getDownloadURL().then(function(url) {
          // `url` is the download URL for 'images/stars.jpg'

          // This can be downloaded directly:
          var xhr = new XMLHttpRequest();
          xhr.responseType = 'blob';
          xhr.onload = function(event) {
            var blob = xhr.response;
            var fileDownload = require('js-file-download');
            fileDownload(blob, file.name);
          };
          xhr.open('GET', url);
          xhr.send();
        });
      },
      deleteFile(file) {
        console.log(file);
        var r = confirm("Are you sure you want to delete this file?");
        console.log(r);
        if (r == true) {
          db.collection("files").doc(file.uid).delete().then(function() {
              console.log("Document successfully deleted!");
              var storageRef = firebase.storage().ref('files/');
              var fileRef = storageRef.child(file.company + '/' + file.name);
              // Delete the file
              fileRef.delete().then(function() {
                // File deleted successfully
                console.log("File successfully deleted!");
              }).catch(function(error) {
                // Uh-oh, an error occurred!
                console.log("There was a problem deletin this file!");
              });
          }).catch(function(error) {
              console.error("Error removing document: ", error);
          });
        } else {
          console.log('Operation stopped by the user')
          console.log('Magtrix effect')
        }

      },

      deleteFolder(folder) {
        var r = confirm("Are you sure you want to delete this folder and all of its' contents?");
        if (r == true) {
          db.collection("folders").doc(folder.uid).delete().then(function() {
              console.log("Document successfully deleted!");
          }).catch(function(error) {
              console.error("Error removing document: ", error);
          });
        } else {
          console.log('Operation stopped by the user')
        }
      },

      deleteClient() {
        var self = this;
        var userConfirm = confirm("Are you sure you want to delete " + this.client.name + "?");
        if (userConfirm == true) {
          db.collection("companies").doc(self.client.uid).delete().then(function() {
            console.log(self.client.name + " deleted");
            document.location.reload();
          }).catch(function(error) {
            console.log("There was an error deleting this client " + error);
          });
        } else {
          console.log("You just saved somebody's life");
        }
      }

    },
    watch: {
        client: function(newVal, oldVal) { // watch it
          this.updateData();
        },
        folder: function(newVal, oldVal) { // watch it
          this.updateData();
        },
        file: function(newVal, oldVal) { // watch it
          this.updateData();
        }
    },
    mounted() {
      console.log(this.client)
      this.updateData();
    },
    beforeUpdated() {
      console.log("Updated life cycle")
      this.updateData();
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  #files-list {
    max-height: 800px;
    overflow: auto;
  }
</style>
